import React, { useState, useEffect } from 'react';

const Event = (props) => 
{ 
    
  const [events, setEvents] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_STRIPE_URL}/products.php?type=event`)
      .then(res => res.json())
      .then(data => setEvents (data));
  }, []);

    

    if (props.lang === "EN") {
        return (<div>  
      <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
      {events.map(event => {
        // default_price can be null if not set
        const price = event.default_price?.unit_amount
          ? (event.default_price.unit_amount / 100).toFixed(2)
          : "N/A";
        const currency = event.default_price?.currency?.toUpperCase() || "";

        // For payment link: you could have price ID or checkout URL
        const checkoutUrl = `${process.env.REACT_APP_STRIPE_URL}/checkout.php?price_id=${event.default_price?.id}`;

        return (
          <div key={event.id} style={{
            border: "1px solid #ccc",
            padding: "16px",
            width: "200px",
            borderRadius: "8px"
          }}>
            {event.images && event.images[0] && (
              <img
                src={event.images[0]}
                alt={event.name}
                style={{ width: "50px", height: "auto", marginBottom: "12px" }}
              />
            )}
            <h3>{event.name}</h3>
            <p>{event.description}</p>
            <p>
              Price: {price} {currency}
            </p>
            {event.default_price && (
              <a href={checkoutUrl}>
                <button style={{
                  padding: "10px 16px",
                  background: "#6772e5",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer"
                }}>
                  Buy Now
                </button>
              </a>
            )}
          </div>
        );
      })}
    </div>
</div>);
    } 
    if (props.lang === "RU") {
        return (<div>
             <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
      {events.map(event => {
        // default_price can be null if not set
        const price = event.default_price?.unit_amount
          ? (event.default_price.unit_amount / 100).toFixed(2)
          : "N/A";
        const currency = event.default_price?.currency?.toUpperCase() || "";

        // For payment link: you could have price ID or checkout URL
        const checkoutUrl = `${process.env.REACT_APP_STRIPE_URL}/checkout.php?price_id=${event.default_price?.id}`;

        return (
          <div key={event.id} style={{
            border: "1px solid #ccc",
            padding: "16px",
            width: "200px",
            borderRadius: "8px"
          }}>
            {event.images && event.images[0] && (
              <img
                src={event.images[0]}
                alt={event.name}
                style={{ width: "50px", height: "auto", marginBottom: "12px" }}
              />
            )}
            <h3>{event.name}</h3>
            <p>{event.description}</p>
            <p>
              Price: {price} {currency}
            </p>
            {event.default_price && (
              <a href={checkoutUrl}>
                <button style={{
                  padding: "10px 16px",
                  background: "#6772e5",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer"
                }}>
                  Buy Now
                </button>
              </a>
            )}
          </div>
        );
      })}
    </div>
        </div>);
    }
}
export default Event;
